import React, { useState } from "react";
import { Box, Button, Collapse, Typography } from "@material-ui/core";
import { Ball, CollapseBody, CollapseHeader, CollapseHeaderInfo, DeliveryImage, DeliveryTypography, Line } from "./orderDetailsCollapseOrder.style";
import { OrderDetailsItem } from "../item/orderDetailsItem";

import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from '@material-ui/icons'
import { OrderDetailsStatus } from "../status/orderDetailsStatus";


export const OrderDetailsCollapseOrder = ({ order }) => {

    const [collapseIsopen, setCollapseIsOpen] = useState(false);

    const lastHistory = order.status.history[order.status.history.length - 1];

    const handleOpenUrl = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    return (
        <Box marginBottom='16px'>
            <CollapseHeader open={collapseIsopen}>
                <CollapseHeaderInfo>
                    <Typography style={{ fontWeight: 'bold' }} > #{order.cardId}</Typography>
                    <OrderDetailsItem title='Tipo' label={order.type === 'Delivery' && order.modality === 'Delivery' ? 'Delivery' : `${order.type} (${order.modality})`} />
                    <OrderDetailsItem title='Data do pedido' label={order.createdAt} />
                    {order.coupon && <OrderDetailsItem title='Cupom' label={order.coupon} />}
                    {order.appointmentDate && <OrderDetailsItem title='Data do agendamento' label={order.appointmentDate} />}
                    {lastHistory && <OrderDetailsStatus status={lastHistory}> {lastHistory.status} </OrderDetailsStatus>}
                    {
                        (order.type === 'Delivery' && order.deliveryPlatform.name) && (
                            <Box display="flex" alignItems="center">
                                <DeliveryImage src={order.deliveryPlatform.src} />
                                <Box>
                                    <Typography style={{ fontSize: '12px' }}>{order.deliveryPlatform.name}</Typography>
                                    {order.deliveryPlatform.url && (
                                        <DeliveryTypography onClick={() => handleOpenUrl(order.deliveryPlatform.url)}>Acompanhar entrega</DeliveryTypography>
                                    )}
                                </Box>
                            </Box>
                        )
                    }
                </CollapseHeaderInfo>
                <Box>
                    <Button
                        style={{ width: '137px', minWidth: '137px', justifyContent: 'flex-end' }}
                        onClick={() => setCollapseIsOpen(!collapseIsopen)}
                        endIcon={collapseIsopen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    >
                        <span style={{ fontSize: 10, textTransform: 'initial' }}>
                            {collapseIsopen ? 'Ocultar histórico' : 'Mostrar histórico'}
                        </span>
                    </Button>
                </Box>
            </CollapseHeader>
            <CollapseBody in={collapseIsopen}>
                <Line width={`calc(((100% / ${order.status.history.length}) * ${order.status.history.length - 1}) - 30px)`}></Line>
                <Box padding='12px 24px' display='flex' justifyContent='space-between'>
                    {
                        order.status.history.map((status, index, { length }) => (
                            <Box
                                width={`calc(100% / ${length} )`}
                                maxWidth={`calc(100% / ${length} )`}
                                key={index}
                                display='flex'
                                flexDirection='column'
                                alignItems='center'
                            >
                                <Ball></Ball>
                                <OrderDetailsStatus
                                    status={status}
                                    showDate
                                >
                                    {status.status}
                                </OrderDetailsStatus>
                            </Box>
                        ))
                    }
                </Box>
            </CollapseBody>
        </Box>
    )
}
